import HBAvatar from "@/components/Avatar";
import { ChatDialog } from "@/components/Chat";
import { CONVERSATION_TYPE } from "@/components/Chat/viewModel";
import Image from "@/components/Image";
import { MessageList } from "@/components/Notify";
import useAppStore from "@/context/store";
import {
  getConversationList,
  getGrocery,
  setDMAllReaded,
  setSystemDMReaded,
} from "@/services";
import getTimeDuration from "@/utils/getTimeDuration";
import { cleanHtmlTag } from "@/utils/str";
import useRequest from "@/utils/useReq";
import { useSafeState, useSetState } from "ahooks";
import { Dropdown, Tabs } from "antd";
import classNames from "classnames";
import Link from "next/link";
import { useCallback, useEffect, useState } from "react";
import HBIcon from "../../HBIcon";
import { NavPopoverAd } from "../NavPopoverAd";
import styles from "./index.module.less";

export default function RightNav({ user, unreadNum, dmUnread }) {
  const [status, setActiveStatus] = useState(false);

  const { data: platformData, loading } = useRequest(async () => {
    const { cardList, toolList } = (await getGrocery("f3xgpedu91c")) || {};

    let mapList = [...(cardList || []), ...(toolList || [])];
    for (let i = 0; i < mapList.length; i++) {
      const item = mapList[i];
      if (item.activeKey && !localStorage.getItem(item.activeKey)) {
        setActiveStatus(true);
      }
    }

    return { cardList, toolList };
  });

  const { unread_dm = 0 } = dmUnread || {};

  const totalUnread = unreadNum + unread_dm;

  const platformClick = useCallback(
    (item) => {
      localStorage.setItem(item.activeKey, true);
      const { cardList = [], toolList = [] } = platformData || {};
      let mapList = [...cardList, ...toolList];
      for (let i = 0; i < mapList.length; i++) {
        const data = mapList[i];
        if (data.activeKey && !localStorage.getItem(data.activeKey)) {
          setActiveStatus(true);
          return;
        }
      }
      setActiveStatus(false);
    },
    [platformData]
  );

  const onPlatformVisibleChange = useCallback(
    (e) => {
      if (e === false) {
        platformData?.cardList?.forEach((item) => {
          if (item.activeKey) {
            localStorage.setItem(item.activeKey, true);
          }
        });
        platformData?.toolList?.forEach((item) => {
          if (item.activeKey) {
            localStorage.setItem(item.activeKey, true);
          }
        });
        setActiveStatus(false);
      }
    },
    [platformData]
  );

  return (
    <div className={styles.nav} style={{ paddingLeft: 4 }}>
      <Dropdown
        className={styles.avatar}
        onVisibleChange={onPlatformVisibleChange}
        destroyPopupOnHide
        overlay={
          !loading ? (
            <OtherPlatform
              platformData={platformData}
              onClick={platformClick}
            />
          ) : (
            ""
          )
        }
        placement="bottomRight"
        getPopupContainer={(triggerNode) => triggerNode}
      >
        <span
          className={classNames("header-item", {
            [styles.unread]: status,
          })}
        >
          <HBIcon type="ic_widgets" />
        </span>
      </Dropdown>
      {user && (
        <Dropdown
          overlay={<NotifyDrop unreadNum={unreadNum} dmUnread={dmUnread} />}
          placement="bottomRight"
          getPopupContainer={(triggerNode) => triggerNode}
          destroyPopupOnHide
        >
          <span className={classNames("header-item", styles.notifications)}>
            {totalUnread > 0 && (
              <div
                className={styles.unreadNum}
                style={totalUnread > 9 ? { padding: "0 2px" } : {}}
              >
                {totalUnread > 99 ? "99+" : totalUnread}
              </div>
            )}
            <HBIcon type="ic_notifications" />
          </span>
        </Dropdown>
      )}
    </div>
  );
}
/**右上角横幅资源位 */
export function RightNavPopover({ isLogin, ad }) {
  if (ad) {
    return <NavPopoverAd ad={ad}></NavPopoverAd>;
  }

  return (
    <Link href="/about/goodies">
      <a
        className={styles.pluginPopover}
        data-gd-click="button_click"
        data-button-name="花瓣浏览器插件"
        rel="nofollow"
      >
        <div
          className={classNames(styles.content, { [styles.folded]: isLogin })}
        >
          <Image
            src={
              "https://cdn.dancf.com/fe-assets/20221130/3ca8a3f9feb02f7cd84422bb64c51353.gif?x-oss-process=image/resize,w_80"
            }
            alt="插件"
            width={40}
            height={32}
          ></Image>
          <span className={styles.text}>采集插件全新上线！</span>
        </div>
      </a>
    </Link>
  );
}

function NotifyDrop({ unreadNum, dmUnread }) {
  const { unread_dm = 0 } = dmUnread || {};
  const [defaultActiveKey] = useSafeState(
    unreadNum > 0 && unread_dm === 0 ? "message" : "dm"
  );
  const [chatProps, setChatProps] = useSetState({
    visible: false,
    targetUserId: null,
  });

  const [hasReadList, setHasReadList] = useSafeState([]);

  useEffect(() => {
    if (chatProps.visible) {
      ChatDialog.open({
        ...chatProps,
        onCancel() {
          setChatProps({ visible: false });
        },
      });
    }
  }, [chatProps, setChatProps]);

  useEffect(() => {
    if (hasReadList.includes(chatProps.targetUserId)) return;

    setHasReadList([...hasReadList, chatProps.targetUserId]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatProps?.targetUserId]);

  const { data: conversationList, refresh: refreshConversationList } =
    useRequest(async () => {
      const res = await getConversationList({
        limit: 100,
      });

      const unreadList = res.conversations.filter((item) => item.unread);
      const readList = res.conversations.filter((item) => !item.unread);

      return [...unreadList, ...readList];
    }, []);

  const systemAvatar =
    "https://cdn.dancf.com/fe-assets/img/cd8cef63868baa9debd5eefafa7d93af.png";

  return (
    <div className={styles.notify}>
      <Tabs defaultActiveKey={defaultActiveKey}>
        <Tabs.TabPane
          tab={
            <div className={styles.tabTitle}>
              私信
              {unread_dm > 0 && (
                <div
                  className={styles.unreadNum}
                  style={unread_dm > 9 ? { padding: "0 2px" } : {}}
                >
                  {unread_dm > 99 ? "99+" : unread_dm}
                </div>
              )}
            </div>
          }
          key="dm"
          className={styles.tabPane}
        >
          {conversationList?.length > 0 && (
            <div className={styles.conversationList}>
              {conversationList.map((record, idx) => {
                const { with_user, last_message, unread, text, created_at } =
                  record;

                return (
                  <div
                    key={idx}
                    className={classNames(styles.conversationItem, {
                      [styles.hasNews]:
                        unread &&
                        !hasReadList.includes(
                          with_user?.user_id || CONVERSATION_TYPE.SYSTEM
                        ),
                    })}
                    onClick={() =>
                      setChatProps({
                        visible: true,
                        targetUserId:
                          with_user?.user_id || CONVERSATION_TYPE.SYSTEM,
                      })
                    }
                  >
                    {with_user ? (
                      <>
                        <HBAvatar
                          className={styles.conversationAvatar}
                          user={with_user}
                          shape="circle"
                          size={32}
                        />
                        <div className={styles.info}>
                          <div className={styles.name}>
                            {with_user.username}
                          </div>
                          <div
                            className={styles.message}
                            title={last_message.text}
                          >
                            {last_message.text.substring(0, 19) +
                              (last_message.text?.length > 19 ? "..." : "")}
                            <span className={styles.time}>
                              {getTimeDuration(last_message.created_at * 1000)}
                            </span>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <HBAvatar
                          className={styles.conversationAvatar}
                          imgUrl={systemAvatar}
                          shape="circle"
                          size={32}
                        />
                        <div className={styles.info}>
                          <div className={styles.name}>系统消息</div>
                          <div className={styles.message}>
                            {cleanHtmlTag(text).substring(0, 19) + "..."}
                            <span className={styles.time}>
                              {getTimeDuration(created_at * 1000)}
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                );
              })}
            </div>
          )}
          {conversationList?.length === 0 && (
            <div className={styles.empty}>还没有私信消息哦 ~</div>
          )}
          <div
            className={styles.bottom}
            style={{ justifyContent: "space-between" }}
          >
            <a
              onClick={async () => {
                await setSystemDMReaded();
                await setDMAllReaded();
                refreshConversationList();
                useAppStore.setState({
                  dmUnread: { unread_system_dm: 0, unread_dm: 0 },
                });
              }}
            >
              <span>全部已读</span>
            </a>
            <a onClick={() => setChatProps({ visible: true })}>
              <span>
                查看所有私信 <HBIcon type="ic_chevron_right" />
              </span>
            </a>
          </div>
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={
            <div className={styles.tabTitle}>
              动态
              {unreadNum > 0 && (
                <div
                  className={styles.unreadNum}
                  style={unreadNum > 9 ? { padding: "0 2px" } : {}}
                >
                  {unreadNum > 99 ? "99+" : unreadNum}
                </div>
              )}
            </div>
          }
          key="message"
          className={styles.tabPane}
        >
          <MessageList
            wrapId={"message-wrap"}
            type={"all"}
            height={283}
            limit={20}
            avatarSize={32}
            onLoad={() => {
              useAppStore.setState({
                unreadNum: 0,
              });
            }}
            itemStyle={{ margin: "2px 20px 10px 0", padding: "0" }}
          />
          <div className={styles.bottom}>
            <Link href={"/message"}>
              <a>
                <span>
                  查看所有动态 <HBIcon type="ic_chevron_right" />
                </span>
              </a>
            </Link>
          </div>
        </Tabs.TabPane>
      </Tabs>
      {/* <ChatModal
        {...chatProps}
        onCancel={() => setChatProps({ visible: false })}
      /> */}
    </div>
  );
}

function OtherPlatform({ platformData, onClick }) {
  return (
    <div
      className={styles.platform}
      data-content-source="九宫格"
      data-resource-title="九宫格"
      data-resource-type="下拉弹窗"
      data-gd-expose="resource_loc_expose"
    >
      <div className={styles.cardList}>
        {platformData.cardList.map((item, index) => (
          <Card key={index} item={item} onClick={onClick} />
        ))}
      </div>
      <div className={styles.more}>
        {platformData.toolList?.map((el, index) =>
          el.type === "divider" ? (
            <div className={styles.divider} key={index}></div>
          ) : (
            <Link href={el.href} key={index}>
              <a
                target={el.type === "inner" ? "_self" : "_blank"}
                data-gd-click="button_click"
                data-button-name={el.title}
                onClick={() => onClick && onClick(el)}
                className={classNames({
                  [styles.news]:
                    el.activeKey && !localStorage.getItem(el.activeKey),
                })}
              >
                <Image
                  src={el.icon[0].url}
                  alt={el.title}
                  width={40}
                  height={40}
                />
                <div>
                  <h5>{el.title}</h5>
                  <span>{el.desc}</span>
                </div>

                <HBIcon
                  type={"launch"}
                  style={{
                    transform:
                      el.type === "inner" ? "rotate(45deg)" : "rotate(0deg)",
                  }}
                />
              </a>
            </Link>
          )
        )}
      </div>
      <div className={styles.bottom}>
        <Link href="/about">
          <a
            target="_blank"
            data-gd-click="button_click"
            data-button-name="关于花瓣"
          >
            <span>关于花瓣</span>
          </a>
        </Link>
        <div className={styles.line}>|</div>
        <Link href="https://support.qq.com/products/30852/change-log">
          <a
            target="_blank"
            data-gd-click="button_click"
            data-button-name="更新日志"
          >
            <span>更新日志</span>
          </a>
        </Link>
        <div className={styles.line}>|</div>
        <Link href="/about/contact">
          <a
            target="_blank"
            data-gd-click="button_click"
            data-button-name="联系我们"
          >
            <span>联系我们</span>
          </a>
        </Link>
        <div className={styles.line}>|</div>
        <Link href="https://support.qq.com/products/30852/faqs-more/?id=108926">
          <a
            target="_blank"
            data-gd-click="button_click"
            data-button-name="侵权投诉"
          >
            <span>侵权投诉</span>
          </a>
        </Link>
      </div>
    </div>
  );
}

function Card({ item, onClick } = {}) {
  return (
    <Link href={item.href}>
      <a
        className={styles.card}
        onClick={() => onClick(item)}
        data-gd-click="button_click"
        data-button-name={item.title}
      >
        <div
          className={styles.bg}
          style={{
            backgroundImage: `url(${item.background[0].url})`,
          }}
        ></div>
        <div className={styles.title}>
          {item.title}
          {item.activeKey && !localStorage.getItem(item.activeKey) && (
            <Image
              className={styles.newsImg}
              src={"https://st0.dancf.com/static/02/202205050532-04fd.svg"}
              width="26"
              alt="new"
            />
          )}
        </div>
        <div className={styles.desc}>{item.desc}</div>
      </a>
    </Link>
  );
}
